import { Component, Output, EventEmitter, Input } from '@angular/core';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';

@Component({
  selector: 'app-upload-arquivo',
  templateUrl: './upload-arquivo.component.html',
  styleUrls: ['./upload-arquivo.component.css']
})
export class UploadArquivoComponent {

  public title: string;
  @Input() accept: string[];
  @Input() subtitle: string;
  @Output() file = new EventEmitter();

  private readonly DEFAULT_TEXT = 'Clique aqui ou arraste o arquivo';

  constructor() {
    this.title = this.DEFAULT_TEXT;
  }

  upload(event: any) {

    const fileListAsArray = Array.from(event);
    const fileArray = [];
    let fileObject: any;

    fileListAsArray.forEach((item, i) => {
      const file = (event as HTMLInputElement);
      const url = URL.createObjectURL(file[i]);
      fileArray[0] = { item, url };
    });

    fileArray.forEach((item) => {
      fileObject = item.item;
    });

    const index = fileArray[0].item.name.lastIndexOf('.');

    const extension = fileArray[0].item.name.substr(index + 1, fileArray[0].item.name.length);

     //console.log(extension, this.accept)

    if (this.accept.some(x => {
      return x === extension;
    })) {
      this.title = fileArray[0].item.name.substr(0, index);

      const reader = new FileReader();
      reader.readAsDataURL(fileObject);
      reader.onloadend = () => {
        this.file.emit(reader.result.toString());
      };
    } else {
      this.file.emit(null);
    }

  }
}
